export interface IGetUpdatesArbitrationInput {
  subscribed: boolean;
  dialogSeen: boolean;
  bandDismissed: boolean;
  bandShownThisSession: boolean;
  autoAskUsedThisSession: boolean;
  landedFromNewsletter: boolean;
  footerFormInViewport: boolean;
  engaged: boolean;
}

export interface IGetUpdatesArbitrationResult {
  showAutoDialog: boolean;
  showBand: boolean;
}

export const resolveGetUpdatesAsk = (
  input: IGetUpdatesArbitrationInput
): IGetUpdatesArbitrationResult => {
  if (
    input.subscribed ||
    input.landedFromNewsletter ||
    input.autoAskUsedThisSession
  ) {
    return { showAutoDialog: false, showBand: false };
  }

  if (!input.dialogSeen) {
    return {
      showAutoDialog: input.engaged && !input.footerFormInViewport,
      showBand: false,
    };
  }

  return {
    showAutoDialog: false,
    showBand: !input.bandDismissed && !input.bandShownThisSession,
  };
};
